export enum PaymentType {
  FaxNumber = "FaxNumber",
  Subscription = "Subscription",
}
